/**
 * @class Api
 */

var Api = (function() {
  var Q = require('q');
  var settingsInstance = require('./SettingsInstance.js');
  var customRequest = require('./requestHelper.js').customRequest;
  var mergeQueryParams = require('./requestHelper.js').mergeQueryParams;

  /**
   * HTTP Request
   * @method
   * @name Api#request
   * @param {string} method - http method
   * @param {string} path - path
   * @param {string} url
   * @param {object} body - body parameters / object
   * @param {object} headers - header parameters
   * @param {object} queryParameters - querystring parameters
   * @param {object} form - form data object
   * @param {object} deferred - promise object
   */
  Api.prototype.request = customRequest;

  function Api(options) {
    var domain = typeof options === 'object' ? options.domain : options;
    this.domain = domain ? domain : `${settingsInstance.baseApiNewUrl}/uldk`;
    if (this.domain.length === 0) {
      throw new Error('Domain parameter must be specified as a string.');
    }
  }

  /**
   * Wyszukaj wojewódźtwa
   * @method
   * @name Api#searchVivoideship
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - teryt code or name
   */
  Api.prototype.searchVivoideship = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = `${settingsInstance.baseApiNewUrl}/uldk`,
      path = '',
      parameterPath = '';
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['multipart/form-data'];

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required parameter: id'));
      return deferred.promise;
    }

    if (parameters['id'] !== '') {
      queryParameters['id'] = parameters['id'];
    }

    queryParameters['request'] = 'GetVoivodeshipById';
    queryParameters['result'] = 'voivodeship,id';
    queryParameters['format'] = 'text';
    queryParameters = mergeQueryParams(parameters, queryParameters);
    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false
    };

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  Api.prototype.publishDemand = function(demand, options) {
    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl,
      path = '/api/demand/submit',
      parameterPath = path;
    var body = demand,
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    if (demand === undefined) {
      deferred.reject(new Error('Missing required parameter: demand'));
      return deferred.promise;
    }

    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false
    };

    this.request(
      'POST',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  /**
   * Wyszukaj powiaty
   * @method
   * @name Api#searchCounty
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - teryt code or name
   */
  Api.prototype.searchCounty = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = `${settingsInstance.baseApiNewUrl}/uldk`,
      path = '',
      parameterPath = '';
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/plain'];
    headers['Content-Type'] = ['multipart/form-data'];

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['id'] !== '') {
      queryParameters['id'] = parameters['id'];
    }

    queryParameters['request'] = 'GetCountyById';
    queryParameters['result'] = 'county,id';
    queryParameters['format'] = 'text';
    queryParameters = mergeQueryParams(parameters, queryParameters);
    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false
    };

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  /**
   * Wyszukaj gminy
   * @method
   * @name Api#searchCommune
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - teryt code or name
   */
  Api.prototype.searchCommune = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = `${settingsInstance.baseApiNewUrl}/uldk`,
      path = '',
      parameterPath = '';
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/plain'];
    headers['Content-Type'] = ['multipart/form-data'];

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['id'] !== '') {
      queryParameters['id'] = parameters['id'];
    }

    queryParameters['request'] = 'GetCommuneById';
    queryParameters['result'] = 'commune,id';
    queryParameters['format'] = 'text';
    queryParameters = mergeQueryParams(parameters, queryParameters);
    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false
    };

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  /**
   * Wyszukaj obręb
   * @method
   * @name Api#searchRegion
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - teryt code or name
   */
  Api.prototype.searchRegion = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = `${settingsInstance.baseApiNewUrl}/uldk`,
      path = '',
      parameterPath = '';
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/plain'];
    headers['Content-Type'] = ['multipart/form-data'];

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    if (parameters['id'] !== '') {
      queryParameters['id'] = parameters['id'];
    }

    queryParameters['request'] = 'GetRegionById';
    queryParameters['result'] = 'region,id';
    queryParameters['format'] = 'text';
    queryParameters = mergeQueryParams(parameters, queryParameters);
    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false
    };

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  /**
   * Pobierz działkę ewidencyjną ULDK
   * @method
   * @name Api#getParcelByIdOrNr
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID działki ewidencyjnej
   */
  Api.prototype.getParcelByIdOrNr = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = `${settingsInstance.baseApiNewUrl}/uldk`,
      path = '',
      parameterPath = '';
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/plain'];
    headers['Content-Type'] = ['multipart/form-data'];
    queryParameters['format'] = 'text';
    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    queryParameters['request'] = 'getParcelByIdOrNr';

    if (parameters['id'] !== undefined) {
      queryParameters['id'] = parameters['id'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);
    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false
    };

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  /**
   * Pobierz połączoną geometrię działek ewidencyjnych ULDK
   * @method
   * @name Api#getAggregateArea
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.id - ID działek ewidencyjnych, oddzielonych przecinkiem
   */
  Api.prototype.getAggregateArea = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = `${settingsInstance.baseApiNewUrl}/uldk`,
      path = '',
      parameterPath = '';
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    headers['Accept'] = ['text/plain'];
    headers['Content-Type'] = ['multipart/form-data'];

    if (parameters['id'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: id'));
      return deferred.promise;
    }

    // queryParameters['request'] = 'GetAggregateArea'; old option
    queryParameters['format'] = 'text';
    queryParameters['request'] = 'GetParcelById';
    queryParameters['result'] = 'geom_wkt';

    if (parameters['id'] !== undefined) {
      queryParameters['id'] = parameters['id'];
    }
    queryParameters = mergeQueryParams(parameters, queryParameters);
    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false
    };

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  /**
   * Pobierz współrzędne szukanego adresu
   * @method
   * @name Api#getParcelByIdOrNr
   * @param {object} parameters - method options and parameters
   * @param {string} parameters.address - adres
   */
  Api.prototype.getCoordinationsForAdress = function(parameters, options) {
    if (parameters === undefined) {
      parameters = {};
    }

    var deferred = Q.defer();
    var domain = settingsInstance.searchApiUrl, //do sparametryzowania
      path = '/api/searchAddress',
      parameterPath = path;
    var body = {},
      queryParameters = {},
      headers = {},
      form = {},
      files = {};

    if (parameters['orgid'] !== undefined) {
      headers['orgid'] = parameters['orgid'];
    }

    headers['Accept'] = ['application/json'];
    headers['Content-Type'] = ['application/json'];

    if (parameters['address'] === undefined) {
      deferred.reject(new Error('Missing required  parameter: address'));
      return deferred.promise;
    }

    if (parameters['address'] !== undefined) {
      queryParameters['query'] = parameters['address'];
    }

    queryParameters = mergeQueryParams(parameters, queryParameters);
    options = {
      withCredentials: false,
      hasCsrfToken: false,
      hasContentType: false,
      ignoreGlobalErrors: true
    };

    this.request(
      'GET',
      path,
      domain + parameterPath,
      body,
      headers,
      queryParameters,
      form,
      deferred,
      files,
      options
    );

    return deferred.promise;
  };

  return Api;
})();

exports.Api = Api;
